var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-bread"},[_c('el-breadcrumb',{staticClass:"breadcrumb-container",staticStyle:{"font-size":"15px"},attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.realList),function(item){return _c('el-breadcrumb-item',{key:item.path,attrs:{"to":item.path}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }